export default "__VITE_ASSET__DUz2rE3M__"